<template>
  <component :is="subjectData === undefined ? 'div' : 'b-card'">
    <!-- Alert: No item found -->
    <b-alert variant="danger" :show="subjectData === undefined">
      <h4 class="alert-heading">Error fetching subject data</h4>
      <div class="alert-body">
        No subject found with this subject id. Check
        <b-link class="alert-link" :to="{ name: 'apps-roster-subject-list' }"> Subject List </b-link>
        for other subjects.
      </div>
    </b-alert>

    <b-tabs v-if="subjectData" pills>
      <!-- Tab: Information -->
      <b-tab>
        <template #title>
          <feather-icon icon="InfoIcon" size="16" class="mr-0 mr-sm-50" />
          <span class="d-none d-sm-inline">Information</span>
        </template>
        <subject-edit-tab-information :subject-data.sync="subjectData" class="mt-2 pt-75" />
      </b-tab>
    </b-tabs>
  </component>
</template>

<script>
import { BTab, BTabs, BCard, BAlert, BLink } from 'bootstrap-vue';
import { ref, onUnmounted } from '@vue/composition-api';
import router from '@/router';
import store from '@/store';
import rosterStoreModule from '../rosterStoreModule';
import SubjectEditTabInformation from './SubjectEditTabInformation.vue';

export default {
  components: {
    BTab,
    BTabs,
    BCard,
    BAlert,
    BLink,

    SubjectEditTabInformation,
  },
  setup() {
    const subjectData = ref(null);

    const SUBJECT_APP_STORE_MODULE_NAME = 'app-roster';

    // Register module
    if (!store.hasModule(SUBJECT_APP_STORE_MODULE_NAME))
      store.registerModule(SUBJECT_APP_STORE_MODULE_NAME, rosterStoreModule);

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(SUBJECT_APP_STORE_MODULE_NAME)) store.unregisterModule(SUBJECT_APP_STORE_MODULE_NAME);
    });

    store
      .dispatch('app-roster/fetchSubject', { id: router.currentRoute.params.id })
      .then((response) => {
        subjectData.value = response.data;
      })
      .catch((error) => {
        if (error.response.status === 404) {
          subjectData.value = undefined;
        }
      });

    return {
      subjectData,
    };
  },
};
</script>

<style></style>
